import React from "react";
import { Modal } from "react-bootstrap";
import SkeletonLoader from "components/ui/SkeletonLoader";
import { LogOut, X } from "lucide-react";
import './LogoutModal.css';


interface LogoutModalProps {
    show: boolean;
    onClose: () => void;
    onConfirm: () => void;
    loading?: boolean;
}

const LogoutModal: React.FC<LogoutModalProps> = ({
    show,
    onClose,
    onConfirm,
    loading = false,
}) => {
    return (
        <Modal
            show={show}
            onHide={onClose}
            centered
            backdrop="static"
            contentClassName="dm-content"
            backdropClassName="dm-backdrop"
        >
            <button
                type="button"
                className="dm-close"
                onClick={onClose}
                disabled={loading}
                aria-label="Close"
            >
                <X size={18} />
            </button>

            <Modal.Body className="dm-body">
                <div className="dm-icon">
                    <LogOut size={26} />
                </div>
                <h2 className="dm-title">Confirm Logout</h2>
                <p className="dm-text">
                    Are you sure you want to log out of your account? <br />
                    You’ll need to sign in again to continue.
                </p>
            </Modal.Body>

            <Modal.Footer className="dm-footer">
                <button
                    type="button"
                    className="dm-btn dm-btn-cancel"
                    onClick={onClose}
                    disabled={loading}
                >
                    Cancel
                </button>
                <button
                    type="button"
                    className="dm-btn dm-btn-danger"
                    onClick={onConfirm}
                    disabled={loading}
                >
                    {loading ? (
                        <>
                            <SkeletonLoader inline width={16} height={16} style={{ borderRadius: 4, marginRight: 8 }} />
                            <span>Logging out...</span>
                        </>
                    ) : (
                        "Logout"
                    )}
                </button>
            </Modal.Footer>
        </Modal>
    );
};

export default LogoutModal;